import {
  CreateConceptDocument,
  CreateConceptMutation,
  CreateConceptMutationVariables,
  PayrollConceptsDocument,
} from 'generated/resources/graphql'

import { useMutation } from 'modules/core/hooks/useMutation'

export type CreateConceptPayload = CreateConceptMutation['payrollMutations']['createPayrollConcept']

export const useCreateConcept = () => {
  const [CreateConcept, { loading }] = useMutation(CreateConceptDocument, {
    extractorFn: (data: CreateConceptMutation) => data.payrollMutations.createPayrollConcept,
    refetchQueries: [PayrollConceptsDocument],
  })

  return {
    loading,
    createConcept(variables: CreateConceptMutationVariables) {
      return CreateConcept({
        variables,
      })
    },
  }
}
